export default function Notices() {
  const notices = [
    {
      id: 1,
      category: '공지사항',
      title: '2025년 상반기 정기후원자 모집 안내',
      date: '2025.01.15',
      isNew: true
    },
    {
      id: 2,
      category: '활동소식',
      title: '겨울나기 온정 캠페인 성공적 마무리',
      date: '2025.01.10',
      isNew: true
    },
    {
      id: 3,
      category: '보도자료',
      title: '유앤아이월드, 지역아동센터 후원 협약 체결',
      date: '2025.01.05',
      isNew: false
    },
    {
      id: 4,
      category: '공지사항',
      title: '설 명절 맞이 특별 후원 프로그램 안내',
      date: '2024.12.28',
      isNew: false
    },
    {
      id: 5,
      category: '활동소식',
      title: '연말 사랑나눔 바자회 개최 결과 보고',
      date: '2024.12.20',
      isNew: false
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center justify-between mb-12">
          <div>
            <div className="inline-block bg-blue-50 text-blue-700 px-4 py-2 rounded-full text-sm font-semibold mb-4">
              공지사항
            </div>
            <h2 className="text-4xl font-bold text-gray-900">
              <strong>유앤아이월드</strong> 소식
            </h2>
          </div>
          <a
            href="#all-notices"
            className="hidden md:flex items-center gap-2 text-blue-600 hover:text-blue-700 font-medium transition-colors whitespace-nowrap cursor-pointer"
          >
            전체보기
            <i className="fas fa-arrow-right"></i>
          </a>
        </div>

        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
          {notices.map((notice, index) => (
            <a
              key={notice.id}
              href={`#notice-${notice.id}`}
              className={`flex items-center justify-between p-6 hover:bg-blue-50 transition-colors cursor-pointer ${
                index !== notices.length - 1 ? 'border-b border-gray-100' : ''
              }`}
            >
              <div className="flex items-center gap-6 flex-1">
                <span className="text-blue-600 font-semibold text-lg min-w-[80px]">
                  {notice.category}
                </span>
                <h3 className="text-gray-900 font-medium text-lg flex items-center gap-3">
                  {notice.title}
                  {notice.isNew && (
                    <span className="bg-red-500 text-white text-xs px-2 py-1 rounded-full font-bold whitespace-nowrap">
                      NEW
                    </span>
                  )}
                </h3>
              </div>
              <div className="flex items-center gap-6">
                <span className="text-gray-500 text-sm whitespace-nowrap">{notice.date}</span>
                <i className="fas fa-chevron-right text-gray-400"></i>
              </div>
            </a>
          ))}
        </div>

        <div className="mt-8 text-center md:hidden">
          <a
            href="#all-notices"
            className="inline-flex items-center gap-2 text-blue-600 hover:text-blue-700 font-medium transition-colors whitespace-nowrap cursor-pointer"
          >
            전체보기
            <i className="fas fa-arrow-right"></i>
          </a>
        </div>
      </div>
    </section>
  );
}